<app-header></app-header>

<div class="sidebar-bg" (click)="toggleSidebar()"></div>
<app-sidebar></app-sidebar>

<main class="pb-24 pt-4">
  <app-alerts></app-alerts>

  <router-outlet></router-outlet>
</main>
